import { t } from 'localization/utils/t';

const TP = 'shared.enums.ErrorMessage';

export const DEFAULT_ERROR_MESSAGE = {
  value: t(`${TP}.defaultErrorMessage`, 'Something went wrong. Please try again.'),
  TK: 'defaultErrorMessage',
  TP,
};

export const ERROR_MESSAGE_503 = {
  value: t(`${TP}.serviceTempUnavailable`, 'Service Temporarily Unavailable.'),
  TK: 'serviceTempUnavailable',
  TP,
};
